import { SlotStatus } from "core/types/index";
import { useTemplates } from "hooks/useTemplates";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useCalendarHideCancelledSlots } from "../useCalendarHideCancelledSlots";
import { useCalendarSlots } from "../useCalendarSlots";
import { formatSlots } from "./formatSlots";

const CANCELED_STATUSES = [
  SlotStatus.CANCELED,
  SlotStatus.LATE_CANCELED,
  SlotStatus.NO_SHOW,
  SlotStatus.NO_SHOW_ALL,
] as const;

type Args = {
  isAdmin: boolean;
  isDemo: boolean;
};

export const useSlots = ({ isAdmin, isDemo }: Args) => {
  const { data: templates } = useTemplates();
  const { t } = useTranslation();
  const [hideCancelledSlots] = useCalendarHideCancelledSlots();
  const { data: slotsFromQuery = [] } = useCalendarSlots();
  const formattedSlots = useMemo(
    () => formatSlots(t, slotsFromQuery, isAdmin, isDemo, templates),
    [t, slotsFromQuery, isAdmin, isDemo, templates],
  );
  return useMemo(() => {
    return hideCancelledSlots
      ? formattedSlots.filter(
          (slot) => !CANCELED_STATUSES.some((status) => status === slot.status),
        )
      : formattedSlots;
  }, [formattedSlots, hideCancelledSlots]);
};
